@if (transfersData(); as transfersData) {
  <form class="w-full" data-qa="checkout-transfer-form" [formGroup]="formGroup">
    <div class="h-full p-4">
      <div class="mt-3 grid grid-cols-3 gap-7">
        <div class="mt-3">
          @if (data.tourist.firstName && data.tourist.lastName) {
            {{ data.tourist.firstName }} {{ data.tourist.lastName }}
          }
          @if (!data.tourist.firstName || !data.tourist.lastName) {
            {{ 'Tourist' | translate }} №{{ data.index + 1 }}
          }
        </div>
      </div>
      <ng-container formArrayName="transfers">
        @for (transfersForm of formGroup.controls.transfers.controls; track index; let index = $index) {
          @if (transfersData[index]; as transferData) {
            <ng-container [formGroupName]="index">
              @if (transferData.type === 'Arrival' || transferData.type === 'Departure') {
                @if (transferData?.flightInfo && !transferData?.flightId) {
                  <ng-container
                    [ngTemplateOutlet]="headLineTemplateRef"
                    [ngTemplateOutletContext]="{
                      params: {
                        typeName: transferData.type === 'Arrival' ? 'Arrival' : 'Departure',
                        flightNumber: transferData.flightInfo.flightNumber,
                        terminalCode: transferData.flightInfo.terminalCode,
                        date: transferData.flightInfo.date,
                        time: transferData.flightInfo.time
                      }
                    }"
                  />
                }
                @if (!transferData.flightInfo && transferData.flightId) {
                  @if (getFlight$(transferData.flightId) | async; as flight) {
                    @if (
                      transferData.type === 'Arrival' ? flight.departureSegments?.at(-1) : flight.returnSegments?.at(0);
                      as flightSegment
                    ) {
                      <ng-container
                        [ngTemplateOutlet]="headLineTemplateRef"
                        [ngTemplateOutletContext]="{
                          params: {
                            typeName: transferData.type === 'Arrival' ? 'Arrival' : 'Departure',
                            flightNumber: flightSegment.flightCode,
                            terminalCode:
                              transferData.type === 'Arrival'
                                ? flightSegment.arrivalTerminalCode
                                : flightSegment.departureTerminalCode,
                            dateTime:
                              transferData.type === 'Arrival'
                                ? flightSegment.arrivalFlightDate
                                : flightSegment.departureFlightDate
                          }
                        }"
                      />
                    }
                  }
                }
                <!-- R-HT25 / C12: one column on a phone - two side by side left the car select ~150 px and cut the chosen car -->
                <div
                  class="mt-5 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-7"
                  [attr.data-testid]="'checkout-transfer-leg-row-' + index"
                >
                  @if (transferData.checkInHotelId ?? transferData.checkOutHotelId; as hotelPriceId) {
                    @if (getHotelByPriceId$(hotelPriceId) | async; as hotel) {
                      <input
                        readonly="true"
                        kzInput
                        [attr.id]="'transferHotelName_' + index"
                        [value]="hotel.hotelName"
                      />
                    }
                  }
                  @if (transferData.requirement === 'included' && selectedCar(transferData, index); as car) {
                    <!-- R-HT12: included = the cheapest car, chosen for the agent, no choice -->
                    <p class="text-sm" role="status" [attr.data-testid]="'checkout-transfer-included-' + index">
                      {{ car.name }} - {{ 'included' | translate }}
                      <ng-container
                        [ngTemplateOutlet]="sourceChipTemplateRef"
                        [ngTemplateOutletContext]="{ option: car }"
                      />
                    </p>
                  } @else if (transferData.transferPrices?.length) {
                    <app-selector
                      formControlName="selectedTransferPriceId"
                      optionValue="id"
                      [placeholder]="'Select transfer' | translate"
                      [itemSizePx]="100"
                      [showClear]="!transferData.requirement || transferData.requirement === 'optional'"
                      [inputId]="'selectedTransferPriceId' + index"
                      [attr.data-testid]="'checkout-transfer-select-' + index"
                      [options]="transferData.transferPrices ?? []"
                    >
                      <ng-template #templateSelected let-option>
                        <ng-container *ngTemplateOutlet="carSelectedTemplateRef; context: { option }" />
                      </ng-template>
                      <ng-template #templateOptionLabel let-option>
                        <ng-container *ngTemplateOutlet="servicesSelectorTemplateRef; context: { option }" />
                      </ng-template>
                    </app-selector>
                  } @else {
                    <ng-container
                      [ngTemplateOutlet]="noTransferOffersTemplateRef"
                      [ngTemplateOutletContext]="{ index, transferData }"
                    />
                  }
                </div>
              }
              @if (transferData.type === 'HotelToHotel' && transferData.checkOutHotelId) {
                @if (getHotelByPriceId$(transferData.checkOutHotelId) | async; as checkOutHotel) {
                  <div class="mt-2 bg-kz-layout-featured p-3 flex flex-row justify-between">
                    <div class="flex flex-row gap-2 items-center font-medium">
                      {{ 'From hotel to hotel' | translate }}
                    </div>
                    <div class="text-secondary">{{ checkOutHotel.checkOutDate | date: dateTimeFormat }}</div>
                  </div>
                  <div class="mt-5 grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-7">
                    <input
                      readonly="true"
                      kzInput
                      [attr.id]="'transferCheckOutHotelName_' + index"
                      [value]="checkOutHotel.hotelName"
                    />
                    @if (transferData.checkInHotelId) {
                      @if (getHotelByPriceId$(transferData.checkInHotelId) | async; as checkInHotel) {
                        <input
                          readonly="true"
                          kzInput
                          [attr.id]="'transferCheckInHotelName_' + index"
                          [value]="checkInHotel.hotelName"
                        />
                      }
                    }
                    @if (transferData.transferPrices?.length) {
                      <app-selector
                        formControlName="selectedTransferPriceId"
                        optionValue="id"
                        [placeholder]="'Select transfer' | translate"
                        [inputId]="'selectedTransferPriceId' + index"
                        [attr.data-testid]="'checkout-transfer-select-' + index"
                        [options]="transferData.transferPrices ?? []"
                        [itemSizePx]="100"
                      >
                        <ng-template #templateSelected let-option>
                          <ng-container *ngTemplateOutlet="carSelectedTemplateRef; context: { option }" />
                        </ng-template>
                        <ng-template #templateOptionLabel let-option>
                          <ng-container *ngTemplateOutlet="servicesSelectorTemplateRef; context: { option }" />
                        </ng-template>
                      </app-selector>
                    } @else {
                      <ng-container
                        [ngTemplateOutlet]="noTransferOffersTemplateRef"
                        [ngTemplateOutletContext]="{ index }"
                      />
                    }
                  </div>
                }
              }
            </ng-container>
          }
        }
      </ng-container>
      @if (showsSurchargeNote()) {
        <!-- R-CK33 (website-web#139, Amiran 26.10.2026 "Caption + RU labels"): the car prices above are the agency's sell prices, i.e. the net price
             plus the agency surcharge of the destination / contact (packages-api CreateOutputTransfer, flows/transfers.md C6) - said once under the cars -->
        <p class="mt-2 text-xs text-secondary" data-testid="checkout-transfer-surcharge-note">
          {{ 'Prices include your agency surcharge' | translate }}
        </p>
      }
      @if (data.canCopy) {
        <div class="mt-2">
          <mat-checkbox formControlName="copy" id="copy" color="primary" data-qa="checkout-transfer-copy-checkbox">{{
            'Copy services for other tourists' | translate
          }}</mat-checkbox>
        </div>
      }
    </div>
  </form>
}
<ng-template #sourceChipTemplateRef let-option="option">
  <!-- R-HT9: every car says where it comes from; the supplier's name is data (the channel's configured name).
       website-flags R-WF108: only with website-details-tags - otherwise no chip and no data-source -->
  @if (!detailsTagsHidden()) {
    <span
      class="chip ml-1 text-xs"
      [attr.data-testid]="'checkout-transfer-source-' + option.id"
      [attr.data-source]="option.source"
    >
      @if (option.isLive) {
        {{ option.supplierName }}
      } @else {
        {{ 'Local' | translate }}
      }
    </span>
  }
</ng-template>
<ng-template #servicesSelectorTemplateRef let-option="option" [typedTemplate]="servicesSelectorTemplateTypedToken">
  {{ option.name }}
  <ng-container [ngTemplateOutlet]="sourceChipTemplateRef" [ngTemplateOutletContext]="{ option }" />
  @if (priceCurrency$ | async; as priceCurrency) {
    @if (option.adultPrice || option.childPrice) {
      @if (option.perPersonPrice) {
        <!-- R-CK33 (website-web#139, C21): the per-person labels go through translate - the Russian site read "Adult:" / "Child:" -->
        ({{ option.adultPlaces }}) - {{ 'Adult' | translate }}: {{ option.adultPrice | priceFormat: priceCurrency }}
        {{ 'Child' | translate }}: {{ option.childPrice | priceFormat: priceCurrency }}
      }
      @if (!option.perPersonPrice) {
        ({{ option.adultPlaces + (option.childPlaces ? ' +' + option.childPlaces : '') }}) -
        {{ option.adultPrice | priceFormat: priceCurrency }}
      }
    } @else {
      <!-- R-HT9a: no adult and no child price = priced inside the tour - translated, never "0.00" or the English "INCLUDED" -->
      {{ 'included' | translate }}
    }
  }
</ng-template>
<!-- R-HT25: the chosen car on ONE line inside the single-line select box - name, source, seats, price; the name gives way (ellipsis), nothing is
     cut in half (Amiran 09.10.2026: the 3-line chip showed half of "Standard" and half of the price) -->
<ng-template #carSelectedTemplateRef let-option="option" [typedTemplate]="servicesSelectorTemplateTypedToken">
  <span
    class="flex flex-row flex-nowrap items-center gap-1 w-full min-w-0 overflow-hidden whitespace-nowrap leading-normal"
    [attr.data-testid]="'checkout-transfer-selected-' + option.id"
  >
    <span class="min-w-[3rem] truncate">{{ option.name }}</span>
    <!-- website-flags R-WF108: the source chip only with website-details-tags -->
    @if (!detailsTagsHidden()) {
      <span
        class="chip inline-flex! px-2! py-0! text-xs shrink-0"
        [attr.data-testid]="'checkout-transfer-source-' + option.id"
        [attr.data-source]="option.source"
      >
        @if (option.isLive) {
          {{ option.supplierName }}
        } @else {
          {{ 'Local' | translate }}
        }
      </span>
    }
    @if (option.adultPlaces) {
      <span class="text-xs text-secondary shrink-0">({{ option.adultPlaces }})</span>
    }
    <span class="ml-auto pl-2 shrink-0 font-medium">
      @if (priceCurrency$ | async; as priceCurrency) {
        @if (option.adultPrice || option.childPrice) {
          @if (option.perPersonPrice) {
            {{ 'Adult' | translate }} {{ option.adultPrice | priceFormat: priceCurrency }} · {{ 'Child' | translate }}
            {{ option.childPrice | priceFormat: priceCurrency }}
          } @else {
            {{ option.adultPrice | priceFormat: priceCurrency }}
          }
        } @else {
          {{ 'included' | translate }}
        }
      }
    </span>
  </span>
</ng-template>
<ng-template #noTransferOffersTemplateRef let-index="index" let-transferData="transferData">
  @if (transferData?.requirement === 'mandatory' || transferData?.requirement === 'included') {
    <!-- R-HT13: a required transfer nobody can price = the offer is not sold; before an airport is chosen the agent is asked for it -->
    @if (transferData.notOffered) {
      <p class="text-sm text-kz-danger" role="alert" [attr.data-testid]="'checkout-transfer-not-offered-' + index">
        {{
          'No supplier can price a transfer for this airport and hotel, so this offer cannot be booked. Choose another airport or hotel.'
            | translate
        }}
      </p>
    } @else {
      <p class="text-sm text-secondary" role="status" [attr.data-testid]="'checkout-transfer-choose-airport-' + index">
        {{ 'Choose the arrival or departure airport to see the transfers.' | translate }}
      </p>
    }
  } @else {
    <!-- R-HT4: an optional transfer with nothing to offer says so; the agent continues without it (the selector is not required) -->
    <p class="text-sm text-secondary" role="status" [attr.data-testid]="'checkout-transfer-empty-' + index">
      {{ 'No transfer offers for this airport and hotel - you can continue without a transfer' | translate }}
    </p>
  }
</ng-template>
<ng-template #headLineTemplateRef let-params="params" [typedTemplate]="headLineTemplateTypedToken">
  <div class="mt-3 bg-kz-layout-featured p-3 flex flex-row justify-between">
    <div class="flex flex-row gap-2 items-center">
      <div class="font-medium">
        {{ params.typeName | translate }}
      </div>
      <div class="text-secondary">{{ params.flightNumber ?? 'N/A' }}, {{ params.terminalCode }}</div>
    </div>
    <div class="text-secondary">
      @if (params.date) {
        {{ params.date | date: dateFormat }}
        @if (params.time) {
          , {{ params.time }}
        }
      }
      @if (params.dateTime) {
        {{ params.dateTime | date: dateTimeFormat }}
      }
    </div>
  </div>
</ng-template>

<ng-template #modalFooterTemplateRef>
  <div class="py-3 flex items-center justify-center">
    <button
      mat-flat-button
      color="primary"
      class="medium-size mt-2 w-[15rem!important]"
      data-qa="checkout-transfer-save-button"
      type="submit"
      (click)="onSubmit()"
    >
      {{ 'Save' | translate }}
    </button>
  </div>
</ng-template>
